import React from "react";
import { Link } from "react-router-dom";

const getConfigurationsColumns = (inactiveFunc) => {
  return [
    {
      title: "S.No",
      dataIndex: "key",
      render: (text, record, index) => <span>{index + 1}</span>,
      width: "10%",
    },
    {
      title: "CRM Current Campaign",
      dataIndex: "crmCurrentCampaign",
      width: "30%",
    },
    {
      title: "Cut Of ShareClass Date",
      dataIndex: "cutOfShareClassDate",
      width: "30%",
    },
    {
      title: "CRM Current Campaign",
      dataIndex: "crmCurrentCampaign",
      width: "30%",
    },

    {
      title: "Action",
      className: "text-end",
      render: (text, record) => (
        <div className="dropdown dropdown-action text-end">
          <Link
            to="#"
            className="action-icon dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="material-icons">more_vert</i>
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link className="dropdown-item" to={`/edit-campiagn/${record.id}`}>
              <i className="fa fa-pencil m-r-5" /> Edit
            </Link>
            {/* <button
              className="dropdown-item"
              onClick={() => inactiveFunc(record.id)}
            >
              <i className="fa fa-ban m-r-5" /> Inactive
            </button> */}
          </div>
        </div>
      ),
      width: "30%",
    },
  ];
};

export default getConfigurationsColumns;
